import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NgControl, ControlValueAccessor } from '@angular/forms';

@Component({
    selector: 'app-dropdown-wrapper',
    template: `
        <div 
            [ngClass]='form-field-loader-container'>
            <ag-select
                [(ngModel)]="value"
                (touched)="fieldTouched()"
                [errorMessage]="errorMessage || getErrorMsg()"
                [values]="values"
                [disabled]="isDisabled"
                [bindProperty]="bindProperty"
                (ngModelChange)="valueChanged($event)"
                [label]="required ? label + ' *' : label">
            </ag-select>
            <ag-loader
                class="form-field-loader"
                [visible]="isLoading"
                [position]="'relative'"
                [small]="true"
            ></ag-loader>
            <span
                [ngClass]="errorMessage || getErrorMsg()
                ? 'form-field-description-pushed-down'
                : 'form-field-description'">
                {{description}}
            </span>
        </div>
    `
})
export class AppDropdownWrapperComponent implements OnChanges, ControlValueAccessor {

    @Input() required = false;
    @Input() label: string;
    @Input() values: any = [];
    @Input() errorMessage: string;
    @Input() isLoading: boolean;
    @Input() description: string;
    @Input() bindProperty = 'name';
    @Input() isDisabled: boolean;
    value: any;
    onChange: (value) => void;
    onTouched: () => void;

    constructor(private formControl: NgControl) {
        this.formControl.valueAccessor = this;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.errorMessage && !changes.errorMessage.firstChange) {
            this.errorMessage = changes.errorMessage.currentValue;
        }
        if (changes.values && !changes.values.firstChange) {
            this.values = changes.values.currentValue;
        }
    }

    getErrorMsg() {
        const errors = this.formControl.control.errors || {};
        if (!this.formControl.control.touched) {
            return;
        }

        if ('required' in errors || (this.required && !this.value)) {
            return 'This field is required';
        }
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    writeValue(obj: any): void {
        this.value = obj;
    }

    setDisabledState(isDisabled: boolean) {
        this.isDisabled = isDisabled;
    }

    valueChanged(newValue) {
        this.onChange(newValue);
        this.onTouched();
    }

    fieldTouched() {
        this.onTouched();
    }

    onBlur($event) {
        this.onTouched();
    }
}
